import React, { Component } from "react";
import PropTypes from "prop-types";
import { aplhaNumericDash } from "../../../../lib/utils/regex_cheat_sheet";
import { getCountry } from "../../../../lib/myProfile";
// import ModalPopupComponent from "../../../ModalPopupComponent/theme5mobile/ModalPopupComponent";
import ModalPopupComponent from "../../../ModalPopupComponent/theme11/ModalPopupComponent";

class IsdCodeDropdown extends Component {
  constructor(props) {
    super(props);
    this.dropdownRef = React.createRef();
    this.state = {
      searchQuery: "",
      dropdownVisible: false,
      selectedCountry: null,
      countryData: [],
    };
  }

  componentDidMount() {
    getCountry().then((data) => {
      if (data.status) {
        this.setState({ countryData: data?.data || [] }, () => {
          if (this.state.countryData.length > 0) {
            const defaultData = this.state.countryData.filter(
              (country) =>
                country.contry_isd ===
                this.props?.value?.toString().replace("+", "")
            );
            if (defaultData.length > 0) {
              this.setState({
                selectedCountry: defaultData[0],
                searchQuery: defaultData[0].contry_isd,
              });
            }
          }
        });
      }
    });
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      const defaultData = this.state.countryData.filter((country) => {
        return typeof nextProps?.value == "number"
          ? country.contry_isd == nextProps.value
          : country.contry_isd === nextProps.value?.toString().replace("+", "");
      });
      if (defaultData.length > 0) {
        this.setState({
          selectedCountry: defaultData[0],
          searchQuery: defaultData[0].contry_isd,
        });
      } else {
        this.setState({
          selectedCountry: null,
          searchQuery: "",
        });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleOutsideClick = (event) => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({ dropdownVisible: false }, () => {
        if (
          this.props?.autoPopulateOnOutsideClick &&
          this.state.selectedCountry == null
        ) {
          const copyData = this.state.countryData.filter(
            (country) => country?.contry_isd == "91"
          );
          if (copyData.length > 0) {
            this.handleCountrySelect(copyData[0]);
          }
        }
      });
    }
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownVisible: true,
    }));
  };

  handleSearchChange = ({ target: { value } }) => {
    this.setState({ searchQuery: value.replace(aplhaNumericDash, "") }, () => {
      if (this.state.searchQuery !== "") {
        const copyData = this.state.countryData.filter((country) => {
          country.contry_isd == this.state.searchQuery ||
            country.contry_name.toLowerCase() ==
              this.state.searchQuery.toLowerCase();
        });
        if (copyData.length > 0) {
          this.setState({ selectedCountry: copyData[0] }, () => {
            if (this.props.onSelect) {
              this.props.onSelect(this.state.selectedCountry);
            }
          });
        } else {
          this.setState({ selectedCountry: null }, () => {
            if (this.props.onSelect) {
              this.props.onSelect({
                contry_name: "",
                contry_code: "",
                contry_flag: "",
                contry_isd: "",
              });
            }
          });
        }
      } else {
        this.setState({ selectedCountry: null }, () => {
          if (this.props.onSelect) {
            this.props.onSelect({
              contry_name: "",
              contry_code: "",
              contry_flag: "",
              contry_isd: "",
            });
          }
        });
      }
    });
  };

  handleCountrySelect = (country) => {
    this.setState({
      selectedCountry: country,
      dropdownVisible: false,
      searchQuery: country.contry_isd,
    });
    if (this.props.onSelect) {
      this.props.onSelect(country);
    }
  };

  filterCountries = () => {
    const { searchQuery, countryData } = this.state;
    if (!searchQuery) return countryData;
    const searchLower = searchQuery.toLowerCase();
    return countryData.filter((country) => {
      return (
        country.contry_name.toLowerCase().includes(searchLower) ||
        country.contry_isd.includes(searchQuery)
      );
    });
  };

  onInputClick = () => {
    const defaultData = this.state.countryData.filter(
      (country) =>
        country.contry_isd === this.props.value?.toString().replace("+", "")
    );
    if (defaultData.length > 0) {
      this.setState({ selectedCountry: defaultData[0] }, () => {
        if (this.props.onSelect) {
          this.props.onSelect(this.state.selectedCountry);
          //  this.handleSearchChange({ target: { value: this.state.selectedCountry.contry_isd } });
        }
      });
    }
  };

  render() {
    const {
      label = "ISD Code",
      placeholder = "ISD Code",
      showFlag = true,
      showCountryCode = true,
      showISDCode = true,
      styles = {},
      showCountryName = true,
      showLabel = false,
      isMobile = false,
      ModalCssMobile,
      arrowIcon = (
      <img src="images/te_register_drop_icon.svg" alt="arrow down" className={styles?.arrow_icon} />
      ),
      disabled = true,
    } = this.props;

    const { searchQuery, dropdownVisible, selectedCountry, countryData } =
      this.state;
    const filteredCountries = this.filterCountries();

    return (
      <div
        className={`${styles?.isd_dropdown} ${
          disabled ? "" : styles?.isd_input_container_disabled
        } isd_drop_cont`}
        ref={this.dropdownRef}
      >
        {/* {label && showLabel && (
          <label className={styles?.isd_label}>{label}*</label>
        )} */}
        <div
          className={`${styles?.isd_input_container}`}
          onClick={this.toggleDropdown}
        >
          <div
            className={`${styles?.isd_input} ${
              selectedCountry && showFlag ? "" : styles?.isd_input_wrapper
            } isd_input_cont`}
            onClick={this.onInputClick}
          >
            {selectedCountry && showFlag && (
              <img
                src={selectedCountry.contry_flag}
                alt="flag"
                className={styles?.isd_flag}
              />
            )}
            {/* {selectedCountry && showISDCode && (
             <span className={styles?.isd_code}>+{selectedCountry.contry_isd}</span>
           )} */}
            {!isMobile ? (
              <input
                type="text"
                value={searchQuery === "" ? "" : "+" + searchQuery}
                onChange={this.handleSearchChange}
                placeholder={
                  selectedCountry === "" || selectedCountry == null
                    ? placeholder || "ISD Code*"
                    : ""
                }
                className={styles?.isd_search}
                disabled={!disabled}
              />
            ) : (
              <input
                type="text"
                value={searchQuery === "" ? "" : "+" + searchQuery}
                // onChange={this.handleSearchChange}
                placeholder={
                  selectedCountry === "" || selectedCountry == null
                    ? placeholder || "ISD Code*"
                    : ""
                }
                className={styles?.isd_search}
                disabled={!disabled}
              />
            )}

            {arrowIcon}
          </div>
        </div>
        {dropdownVisible && !isMobile && (
          <div className={styles?.dropdown_open}>
            <ul className={styles?.dropdown_list}>
              {filteredCountries && (
                <>
                  {filteredCountries.map((country, index) => (
                    <li
                      key={index}
                      className={styles?.dropdown_option}
                      onClick={() => this.handleCountrySelect(country)}
                    >
                      {showFlag && (
                        <img
                          src={country.contry_flag}
                          alt="flag"
                          className={styles?.isd_flag}
                        />
                      )}
                      {showCountryName && (
                        <span className={styles?.isd_name}>
                          {country.contry_name}
                        </span>
                      )}

                      {showISDCode && (
                        <span className={styles?.isd_code}>
                          (+{country.contry_isd})
                        </span>
                      )}

                      {showCountryCode && (
                        <span
                          className={`${styles?.isd_code} ${styles?.isd_code_spc}`}
                        >
                          {country.contry_code}
                        </span>
                      )}
                    </li>
                  ))}
                </>
              )}
              {filteredCountries?.length == 0 && (
                <p className={styles?.no_result_found}>
                  {"No Result Found !!"}
                </p>
              )}
            </ul>
          </div>
        )}
        {dropdownVisible && isMobile && (
          <ModalPopupComponent
            isPopup={dropdownVisible}
            modalCss={ModalCssMobile}
            closePopup={() => {
              this.setState({ dropdownVisible: false });
            }}
            showBtn={false}
            heading={label}
          >
            <div className={styles?.maininput}>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14">
                <defs>
                  <filter id="t14jedxima">
                    <feFlood
                      flood-color="#979797"
                      flood-opacity="1"
                      result="floodOut"
                    ></feFlood>
                    <feComposite
                      operator="atop"
                      in="floodOut"
                      in2="SourceGraphic"
                      result="compOut"
                    ></feComposite>
                    <feBlend in="compOut" in2="SourceGraphic"></feBlend>
                  </filter>
                </defs>
                <g filter="url(#t14jedxima)">
                  <path
                    fill-rule="evenodd"
                    fill="#97144D"
                    d="M10.928 9.513a6.02 6.02 0 1 0-9.812-6.982 6.02 6.02 0 0 0 8.397 8.397l2.83 2.83a1.003 1.003 0 0 0 1.415-1.415l-2.83-2.83zM2.006 6.031a4.015 4.015 0 1 1 6.855 2.84 4.015 4.015 0 0 1-6.855-2.84z"
                  ></path>
                </g>
              </svg>
              <input
                type="text"
                value={searchQuery === "" ? "" : "+" + searchQuery}
                onChange={this.handleSearchChange}
                placeholder={
                  selectedCountry === "" || selectedCountry == null
                    ? placeholder || "ISD Code"
                    : ""
                }
                className={styles?.isd_search}
                autoFocus
              />
            </div>
            {filteredCountries && (
              <div
                className={`${styles?.existing_traveller_panel} ${styles?.book_flight_pop}`}
              >
                <div
                  className={`${styles?.Result_search_box} ${styles?.country_pop} ${styles?.result_country_code}`}
                >
                  <ul className={styles.dropdown_list}>
                    {filteredCountries.map((crrCountry, index) => {
                      return (
                        <li
                          key={index}
                          onClick={(e) => this.handleCountrySelect(crrCountry)}
                          className={styles?.dropdown_option}
                        >
                          <img
                            src={crrCountry?.contry_flag}
                            alt="contry flag"
                          />
                          <span>{crrCountry?.contry_code}</span>
                          <span>{crrCountry?.contry_name}</span>
                          <span>
                            ({"+"}
                            {crrCountry?.contry_isd})
                          </span>
                        </li>
                      );
                    })}
                    {filteredCountries?.length == 0 && (
                      <p className={styles?.no_result_found}>
                        {"No Result Found !!"}
                      </p>
                    )}
                  </ul>
                </div>
              </div>
            )}
          </ModalPopupComponent>
        )}
      </div>
    );
  }
}

IsdCodeDropdown.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  showFlag: PropTypes.bool,
  showCountryCode: PropTypes.bool,
  showCountryName: PropTypes.bool,
  showISDCode: PropTypes.bool,
  onSelect: PropTypes.func,
};

IsdCodeDropdown.defaultProps = {
  showFlag: true,
  showCountryCode: true,
  showCountryName: true,
  showISDCode: true,
};

export default IsdCodeDropdown;
